/*
 * @Author: zhengshuhua
 * @Date: 2021-09-14 09:24:25
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2024-01-09 15:00:10
 * @Description: file content
 * @FilePath: \edc-web\src\local\localapi.js
 */
class Local {
	setLocal(name, info) {
		this.removeLocal(name)
		localStorage.setItem(name, info)
	}
	getLocal(name) {
		if (localStorage.getItem(name)) {
			return localStorage.getItem(name)
		} else {
			return null
		}
	}
	removeLocal(name) {
		localStorage.removeItem(name)
	}
	setSession(name, info) {
		this.removeLocal(name)
		sessionStorage.setItem(name, info)
	}
	getSession(name) {
		if (sessionStorage.getItem(name)) {
			return sessionStorage.getItem(name)
		} else {
			return null
		}
	}
	removeSession(name) {
		sessionStorage.removeItem(name)
	}
}
const local = new Local()
export default local
